export default __webpack_public_path__ + "static/media/menu-arrow.3a1462a9.webp";